var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mRulesPage"}},[_c('iframe',{attrs:{"id":"my-iframe","src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }